import { render, staticRenderFns } from "./TimelineRevisionAgencyAwaitingFeedback.vue?vue&type=template&id=479dbbf4"
import script from "./TimelineRevisionAgencyAwaitingFeedback.vue?vue&type=script&lang=js"
export * from "./TimelineRevisionAgencyAwaitingFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports